export default __webpack_public_path__ + "static/media/diego-montes.b0c59d4d.png";